import PropTypes from 'prop-types';
import React from 'react'
import { findWhere } from 'underscore'

import Questions from '../RegistrationParts/QuestionsTemplate'


export default class extends React.Component {
    static propTypes = {
		changeData: PropTypes.func.isRequired,
		prevSlide: PropTypes.func.isRequired,
		nextSlide: PropTypes.func.isRequired,
		sessionUser: PropTypes.object.isRequired
	};

    constructor(props) {
        super(props);
        var questions = [
			{
				field: 'have_board',
				text: 'Do you have a board in place?'
			},
			{
				field: 'raise_investment',
				text: 'Do you intend on raising investment to grow your business?'
			},
			{
				field: 'first_time',
				text: 'Is this your first time starting a business?'
			}
		]
        questions.map(question => {
			if( question.field in props.sessionUser.custom ) question.answer = props.sessionUser.custom[question.field]
			if( (question.field + '_follow') in props.sessionUser.custom ) question.subQuestion.answer = props.sessionUser.custom[question.field + '_follow']
		})

        this.state = {
			questions: questions
		};
    }

    render() {

		return (

			<Questions 
				changeData={this.props.changeData}
				prevSlide={this.props.prevSlide}
				nextSlide={this.props.nextSlide}
				title="Three growth questions"
				questions={this.state.questions} />

		)

	}
}



// WEBPACK FOOTER //
// ./src/js/views/Registration/RegistrationSlides/AmbitionSlidePart.jsx